/**
 * @date 03/06/2019
 * @author Martin Gabor
 */

import React from "react";

import { VictoryLabel, VictoryPie } from "victory";

class PercentagePieChart extends React.Component {
  render() {
    const { style, value, label } = this.props;

    let colors, data;
    if (value === 0) {
      colors = ["#EA1E53"];
      data = [{ x: "0%", y: 0 }];
    } else if (value === 100) {
      colors = ["#5CD54A"];
      data = [{ x: "100%", y: 100 }];
    } else {
      colors = ["#EA1E53", "#5CD54A"];
      data = [{ x: (100 - value).toFixed(2) + "%", y: 100 - value }, { x: value.toFixed(2) + "%", y: value }];
    }

    return (
      <div style={style}>
        <svg viewBox="0 0 400 400">
          <VictoryPie
            standalone={false}
            colorScale={colors}
            width={400}
            height={400}
            data={data}
            innerRadius={0}
            labelRadius={80}
            style={{ labels: { fontSize: 20, fill: "white" } }}
          />
          <VictoryLabel textAnchor="middle" style={{ fontSize: 22 }} x={200} y={370} text={label} />
        </svg>
      </div>
    );
  }
}

export default PercentagePieChart;



// WEBPACK FOOTER //
// ./src/charts/PercentagePieChart.js